import { apiCall } from '../../../_services/apiCall';
import config from '../../../config/config.json';

const BASE_URL = `${config.POSTLOGIN_API_URL_COMPANY}doc-sense`;

// ---- Documents ----
export const listDocuments = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.financialYearId) query.append('financialYearId', params.financialYearId);
  const qs = query.toString();
  const response = await apiCall(
    `${BASE_URL}/documents${qs ? `?${qs}` : ''}`,
    {}, {}, 'GET'
  );
  return response?.data || [];
};

export const uploadDocument = async (file, financialYearId, locationId, subLocationId) => {
  const formData = new FormData();
  formData.append('file', file);
  if (financialYearId) formData.append('financialYearId', financialYearId);
  if (locationId) formData.append('sourceId', locationId);
  if (subLocationId) formData.append('subLocationId', subLocationId);
  const response = await apiCall(`${BASE_URL}/documents`, {}, formData, 'POST');
  return response?.data;
};

export const getDocumentById = async (id) => {
  const response = await apiCall(`${BASE_URL}/documents/${id}`, {}, {}, 'GET');
  return response?.data;
};

export const getDocumentStatus = async (id) => {
  const response = await apiCall(
    `${BASE_URL}/documents/${id}/status`,
    {}, {}, 'GET', true, false
  );
  return response?.data;
};

// ---- KPIs ----

export const getExtractedKpis = async (id) => {
  const response = await apiCall(`${BASE_URL}/documents/${id}/extracted-kpis`, {}, {}, 'GET');
  return response?.data || [];
};

/**
 * Save reviewed KPIs.
 *
 * updatedKpis: [{
 *   id,              // DocSenseKpiEntity.id — null for new rows, set for updates
 *   extractedKpiId,  // DocSenseExtractedKpiEntity.id
 *   answerId,        // QuantativeDataEntity.id — null for new rows
 *   kpiId, kpiTitle, value, unit, periodStartDate, periodEndDate
 * }]
 *
 * deletedKpis: [{
 *   id,        // DocSenseKpiEntity.id
 *   answerId,  // QuantativeDataEntity.id to delete the answer record too
 * }]
 */
export const saveKpis = async (documentId, updatedKpis, deletedKpis = []) => {
  const response = await apiCall(
    `${BASE_URL}/documents/${documentId}/kpis`,
    {}, { kpis: updatedKpis, deletedKpis }, 'POST'
  );
  return response?.data;
};

export const getSavedKpis = async (id) => {
  const response = await apiCall(`${BASE_URL}/documents/${id}/kpis`, {}, {}, 'GET');
  return response?.data || [];
};